/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ClassNames from 'classnames';

import DivLoader from '../../../components/DivLoader';
import Translate from '../../../components/Translate';

import {PinChange} from '../../../actions/parental/actions-parental';

class PinChangeMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPin: '',
      newPin: '',
      isShown: false,
    };
  }

  componentDidMount() {

    document.getElementById('pinCode') && document.getElementById('pinCode').focus();

    document.getElementById('dummy_submit') && document.getElementById('dummy_submit').addEventListener('focus', ()=> {
      document.getElementById('pinCode') && document.getElementById('pinCode').focus();

    });

    this.setState({
      isShown: this.props.isShown
    });
  }

  componentWillReceiveProps(newProps) {
    let state = {};

    state.isShown = newProps.isShown;

    this.setState(state);

    if (!newProps.parental.inProgress && newProps.parental.isSuccess) {
      this.props.onClose();
    }
  }

  _onOldPinChange = (event) => {

    this.setState({
      oldPin: event.target.value
    });
  }

  _onNewPinChange = (event) => {

    this.setState({
      newPin: event.target.value
    });
  }

  _onSubmit = (event) => {
    event.preventDefault && event.preventDefault();

    this.props.PinChange(this.state.oldPin, this.state.newPin);
  }

  render() {

    const InputClasses = ClassNames({
      'pin-input': true,
      'animate-shake': this.props.parental.isError
    });

    return (<div className="confirm-payment-popup">
      <DivLoader loading={this.props.parental.inProgress} />
      <a className="mw-close ico ico-close pointer slider-resume" onClick={this.props.onClose.bind(this)}></a>
      <form onSubmit={this._onSubmit}>
        <p style={{margin: '0 auto'}}>
          <strong> <Translate content="messages.pin.title" /> </strong>
          <input id="pinCode" type="password" maxLength="4" name="pinCode" className={InputClasses} tabIndex="1"
                 onChange={this._onOldPinChange}
                 value={this.state.oldPin} />
        </p>
        <p style={{margin: '0 auto'}}>
          <strong> <Translate content="messages.pin.new_title" /> </strong>
          <input id="pinNewCode" type="password" maxLength="4" name="pinNewCode" className={InputClasses} tabIndex="2"
                 onChange={this._onNewPinChange}
                 value={this.state.newPin} />
        </p>
        <input id="dummy_submit" type="text" style={{height: 0, width: 0, opacity: 0, display: 'block', float: 'left'}} tabIndex="3" />
        <button type="submit" style={{height: 0, opacity: 0, visibility: 'hidden'}} tabIndex="4">Submit</button>
      </form>
      {this.props.parental.isError && <div className="reg-error-message">
        <em> <Translate content={`error.${this.props.parental.errorMsg}`} /> </em>
      </div>}
      <div className="mt+ message-actions">
        <a className="btn-dark-popup ok" href="javascript:void(0)" onClick={this._onSubmit}> <Translate content="messages.pin.ok" /> </a>
        <a className="btn-dark-popup cancel" href="javascript:void(0)" onClick={this.props.onClose.bind(this)}> <Translate content="messages.pin.cancel" /> </a>
      </div>
    </div>);
  }
}


PinChangeMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

const mapStateToProps = ({parental: {state, inProgress, isError, isSuccess, errorMsg}}) => {

  return {state, parental: {inProgress, isError, isSuccess, errorMsg}}
};
const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({ PinChange }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PinChangeMessage);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/PinChange/pin-change-message.js